<div class="section-details">
    <div class="section-header">
        <div class="section-title-container">
            <div class="section-title">
                {{ "edit-process-information.title" | t }}
            </div>
            <cerrix-instructions-icon
                [instructionText]="
                    'edit-process-information.instructionText' | t
                "
                [showText]="false"
            ></cerrix-instructions-icon>
        </div>
        <div class="section-subtitle">
            {{ "edit-process-information.subTitle" | t }}
        </div>
    </div>
    @if (editModel) {
        <div class="section-fields">
            <app-cerrix-tree-item-picker-multiple
                name="asset-business-dimensions"
                data-uiid="asset-edit-business-dimensions"
                [items]="businessDimensionsList"
                [selectedValue]="editModel.businessDimensions"
                [label]="
                    'edit-process-information.businessDimensionsLabel' | t
                "
                [placeholder]="
                    'edit-process-information.businessDimensionsPlaceholder'
                        | t
                "
                [dialogTitle]="
                    'edit-process-information.businessDimensionsDialogTitle'
                        | t
                "
                [infoText]="
                    'edit-process-information.businessDimensionsInfo' | t
                "
                (valueChanged)="editModel.businessDimensions = $event"
            ></app-cerrix-tree-item-picker-multiple>
            <app-cerrix-tree-item-picker-multiple
                name="asset-organizations-in-use"
                data-uiid="asset-edit-organizations-in-use"
                [items]="organizationsList"
                [selectedValue]="editModel.organizationsInUse"
                [label]="
                    'edit-process-information.organizationsInUseLabel' | t
                "
                [placeholder]="
                    'edit-process-information.organizationsInUsePlaceholder'
                        | t
                "
                [dialogTitle]="
                    'edit-process-information.organizationsInUseDialogTitle'
                        | t
                "
                [infoText]="
                    'edit-process-information.organizationsInUseInfo' | t
                "
                (valueChanged)="editModel.organizationsInUse = $event"
            ></app-cerrix-tree-item-picker-multiple>
            <app-cerrix-user-type-picker
                name="asset-process-users"
                data-uiid="asset-edit-process-users"
                [types]="userTypes"
                [value]="userTypeValue"
                (valueChange)="onUserTypeValueChange($event)"
            ></app-cerrix-user-type-picker>
        </div>
    }
</div>
<div class="slide-out-footer">
    <cerrix-button
        buttonType="secondary"
        buttonSize="big"
        secondaryColor="filled"
        data-uiid="asset-management-edit-cancel"
        (click)="closeEdit.emit()"
    >
        {{ "detail.cancelButton" | t }}
    </cerrix-button>
    <cerrix-button
        buttonType="primary"
        buttonSize="big"
        data-uiid="asset-management-edit-save-section"
        [disabled]="editSaving"
        (click)="save()"
    >
        {{ "detail.editSaveButton" | t }}
    </cerrix-button>
</div>
